import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import StartTime from "./StartTime.js";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
const useStyles = makeStyles((theme) => ({}));
function Weekly(props) {
  const [value, setValue] = useState({ MON: true });
  const classes = useStyles();
  const [startTime, setStartTime] = useState({ minutes: 0, hours: 0 });

  const changeWeeklyValue = (weekValue) => {
    let newValue = { ...value };
    if (newValue[weekValue.currentTarget.value] === true) {
      newValue[weekValue.currentTarget.value] = false;
    } else {
      newValue[weekValue.currentTarget.value] = true;
    }
    setValue(newValue);
    props.returnValue(newValue, startTime);
  };

  const returnStartTime = (time) => {
    setStartTime(time);
    props.returnValue(value, time);
  };
  // const hasEnoughTrueValue = () => {
  //   return Object.values(value).filter((x) => x === true).length > 2;
  // };
  return (
    <div style={{ marginTop: 20 }}>
      <Grid container justify="space-evenly">
        <Grid item justify="flex-start">
          <Checkbox
            color="primary"
            type="checkbox"
            value="MON"
            onChange={changeWeeklyValue}
            checked={value.MON}
          />&nbsp;Monday<br />
          <Checkbox
            color="primary"
            type="checkbox"
            value="WED"
            onChange={changeWeeklyValue}
            checked={value.WED}
          />&nbsp;Wednesday<br />
          <Checkbox
            color="primary"
            type="checkbox"
            value="FRI"
            onChange={changeWeeklyValue}
            checked={value.FRI}
          />&nbsp;Friday<br />
          <Checkbox
            color="primary"
            type="checkbox"
            value="SUN"
            onChange={changeWeeklyValue}
            checked={value.SUN}
          />&nbsp;Sunday
        </Grid>
        <Grid item justify="flex-start">
          <Checkbox
            color="primary"
            type="checkbox"
            value="TUE"
            onChange={changeWeeklyValue}
            checked={value.TUE}
          />&nbsp;Tuesday<br />
          <Checkbox
            color="primary"
            type="checkbox"
            value="THU"
            onChange={changeWeeklyValue}
            checked={value.THU}
          />&nbsp;Thursday<br />
          <Checkbox
            color="primary"
            type="checkbox"
            value="SAT"
            onChange={changeWeeklyValue}
            checked={value.SAT}
          />&nbsp;Saturday
          <br />
          <br />
        </Grid>
      </Grid>
      <StartTime returnValue={returnStartTime} />
    </div>
  );
}

export default Weekly;
